<div class="container">
    <div class="row">
        <div class="col p-0">
            <app-reports-filter
                [selectedReport]="reportModel"
                [generateDisabled]="generateDisabled"
                [showClassFilter]="false"
                [instructors]="instructors"
                (doFilter)="showReport($event)"
                (generateReport)="generateReportFile($event)">
            </app-reports-filter>
        </div>
    </div>
    <div class="row mt-3" *ngIf="reportData.length > 0">
        <div class="col p-0">
            <div class="row instructor-centric-report-header align-items-center">
                <div class="col-4 p-0">
                    <div class="row align-items-center">
                        <div class="col-6">{{ 'InstructorCentricReport.InstructorHeader' | translate }}</div>
                        <div class="col-3 text-center">{{ 'InstructorCentricReport.TotalHoursHeader' | translate }}</div>
                        <div class="col-3 text-center">{{ 'InstructorCentricReport.TotalCostHeader' | translate }}</div>
                    </div>
                </div>
                <div class="col-8 p-0">
                    <div class="row align-items-center">
                        <div class="col-3">{{ 'InstructorCentricReport.ClubNameHeader' | translate }}</div>
                        <div class="col-3">{{ 'InstructorCentricReport.ClassNameHeader' | translate }}</div>
                        <div class="col-2">{{ 'InstructorCentricReport.DateTimeHeader' | translate }}</div>
                        <div class="col-3 text-right">
                            {{ 'InstructorCentricReport.ActualAndBillableTimeHeader' | translate }}
                        </div>
                        <div class="col-1 text-center">{{ 'InstructorCentricReport.CostHeader' | translate }}</div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <app-instructor-centric-report-item *ngFor="let item of reportData" [summaryItem]="item">
                    </app-instructor-centric-report-item>
                </div>
            </div>
        </div>
    </div>
    <div class="row mt-2" *ngIf="reportData.length === 0">
        <div class="col text-center">
            <div><span class="ic-binoculars"></span></div>
            <div>{{ 'InstructorCentricReport.NoRecords' | translate }}</div>
        </div>
    </div>
</div>
